<template>
  <div class="ma-2">
    <v-card-title>
       {{ departamento.description }}
    </v-card-title>

    <v-divider/>
    <v-row dense>
     <v-col cols="5" v-show="dataOperadores">
       <v-data-iterator
          :no-data-text="noDataText"
          :items="dataOperadores"
          :items-per-page.sync="itemsPerPage"
          :page="pageOperators"
          :no-results-text="noResultsText"
          hide-default-footer
        >
          <template v-slot:default="props">
          <v-data-table
            :headers="operatorsHeader"
            :items="props.items"
            :items-per-page="5"
            hide-default-footer
            class="elevation-1"
          >
          </v-data-table>
          </template>

          <template v-slot:footer>
            <v-row class="mt-2" align="center" justify="center">
              <div class="ml-4 mb-2 grey--text">
                <p>
                  Total de Operadores:
                  {{ dataOperadores ? dataOperadores.length : 0 }}
                </p>
              </div>
              <v-spacer />
              <div class="pb-5">
                <ListPagination
                  :page="pageOperators"
                  :numberOfPages="numberOfPagesOperators"
                  @firstPage="firstPageOperators"
                  @formerPage="formerPageOperators"
                  @nextPage="nextPageOperators"
                  @lastPage="lastPageOperators"
                />
              </div>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col> 
    </v-row>  
      
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { registerVuexModule } from '@/utils/vuexUtils'
import ListPagination from '@/componentes/ListPagination'
import departamentosStore from '../_store'

export default {
  components: { ListPagination },
  name: 'Dialog',
  props: {
    departamento: Object,
  },
  data: () => ({
    noDataText: process.env.VUE_APP_NO_DATA_TEXT,
    noResultsText: process.env.VUE_APP_NO_RESULTS_TEXT,
    operatorsHeader: [
        {
          text: 'Operador',
          value: 'agentNumber',
          align: 'left',
          width: '50%',
        },
        {
          text: 'Nome',
          value: 'agentName',
          align: 'left',
        },
    ],
    itemsPerPage: 5,
    pageOperators: 1,
    dataOperadores: []
  }),
  async created() {
    registerVuexModule(this.$store, 'departamentosHomeModuleCallCenterStore', departamentosStore)
  },
  computed: {
    ...mapGetters('departamentosHomeModuleCallCenterStore', ['getDepartamentoUse']),
    numberOfPagesOperators() {
      if(this.dataOperadores){
       return Math.ceil(this.dataOperadores.length / this.itemsPerPage)
      }
      return 0;
    },
  },
  methods: {
    firstPageOperators() {
      if (this.pageOperators > 1) {
        this.pageOperators = 1
      }
    },
    formerPageOperators() {
      if (this.pageOperators > 1) {
        this.pageOperators -= 1
      }
    },
    nextPageOperators() {
      if (this.pageOperators < this.numberOfPagesOperators) {
        this.pageOperators += 1
      }
    },
    lastPageOperators() {
      if (this.pageOperators < this.numberOfPagesOperators) {
        this.pageOperators = this.numberOfPagesOperators
      }
    },
  },
  watch: {
    getDepartamentoUse: {
      deep: true,
      immediate: true,
      handler() {
        this.dataOperadores = this.getDepartamentoUse.agents
      },
    },
  },
}
</script>